import { useSelector } from 'react-redux';

import { RETURN_URL } from 'dpl/constants/query_params';
import { parseQueryString } from 'dpl/util/queryString';

export function useReturnUrl() {
  const { queryParams } = useSelector(state => state);

  const returnUrl = queryParams[RETURN_URL] || null;

  const hashParams = returnUrl
    ? parseQueryString(new URL(returnUrl).hash.replace('#', ''))
    : {};

  return { hashParams, returnUrl };
}
